<template>
    <div v-loading="loading">
        <h2>Orders</h2>
        <ElDivider/>

        <div class="form-box">
            <el-form ref="form" inline stripe :model="queryForm" label-width="80px" style="text-align: center">
                <el-form-item>
                    <el-input clearable v-model="queryForm.orderId" placeholder="Order No."></el-input>
                </el-form-item>

                <el-form-item>
                    <el-select clearable v-model="queryForm.startStatus" placeholder="Start status">
                        <el-option
                                v-for="(value, name) in orderStatus"
                                :key="name"
                                :label="value"
                                :value="name">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item>
                    <el-select clearable v-model="queryForm.endStatus" placeholder="End Status">
                        <el-option
                                v-for="(value, name) in orderStatus"
                                :key="name"
                                :label="value"
                                :value="name">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item>
                    <el-date-picker
                            clearable
                            v-model="queryForm.bookingDate"
                            type="daterange"
                            format="dd-MM-yyyy"
                            value-format="yyyy-MM-dd"
                            start-placeholder="Appointment start"
                            end-placeholder="Appointment end">
                    </el-date-picker>
                </el-form-item>

                <el-form-item>
                    <el-input clearable v-model="queryForm.userName" placeholder="Customer"></el-input>
                </el-form-item>

                <el-form-item>
                    <el-input clearable v-model="queryForm.serviceName" placeholder="Service"></el-input>
                </el-form-item>

                <el-form-item>
                    <el-select clearable v-model="queryForm.paymentStatus" placeholder="Payment Status">
                        <el-option
                                v-for="item in [{value:1,label:'Paid'},{value:2,label:'Unpaid'},{value:3,label:'Partial paid'}]"
                                :key="item.label"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item>
                    <el-select v-model="queryForm.settleStatus" placeholder="Settlement Status" clearable>
                        <el-option
                                v-for="item in [{value:2,label:'Pending'},{value:1,label:'Settled'}]"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item v-if="isEazable">
                    <el-select v-model="queryForm.companyId" placeholder="Vendor" clearable>
                        <el-option
                                v-for="item in vendors"
                                :key="'h-s-'+item.supplierId"
                                :label="item.name"
                                :value="item.supplierId">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item>
                    <el-select v-model="queryForm.employeeId" placeholder="Employee" clearable>
                        <el-option
                                v-for="item in employee"
                                :key="'h-s-a'+item.supplierId"
                                :label="item.name"
                                :value="item.supplierId">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-button type="primary" @click="loadData" icon="el-icon-search" size="medium" circle></el-button>
                <el-button type="primary" @click="exportData" icon="el-icon-download" size="medium" circle></el-button>
            </el-form>
        </div>

        <el-table
                highlight-current-row
                stripe
                :data="data">
            <el-table-column type="expand">
                <template slot-scope="s">
                    <div>
                        <el-form label-width="150px" label-position="left">
                            <el-form-item label="Payment Status">
                                <template v-if="s.row.paymentStatus ===1">
                                    Paid
                                </template>

                                <template v-else-if="s.row.paymentStatus ===3">
                                    Partial paid
                                </template>

                                <template v-else>
                                    Unpaid
                                </template>
                            </el-form-item>

                            <el-form-item label="Settle Status">
                                <template v-if="s.row.settleStatus ===1">
                                    Settled
                                </template>

                                <template v-else>
                                    Pending
                                </template>
                            </el-form-item>
                        </el-form>

                        <el-table
                                :data="s.row.items">
                            <el-table-column
                                    v-for="item in [
                                      {prop:'itemName',label:'Item Name'},
                                      {prop:'paymentBid',label:'Payment Ref'},
                                      {prop:'amount',label:'Amount'},
                                      {prop:'payStatus',label:'Pay Status',fmt:payStatusFormat},
                                      ]" align="center"
                                    :width="item.wth"
                                    :formatter="item.fmt"
                                    :prop="item.prop"
                                    :label="item.label"
                                    :key="item.label">
                            </el-table-column>
                        </el-table>
                    </div>
                </template>
            </el-table-column>

            <el-table-column
                    v-for="item in [
                      {prop:'orderId',label:'Order No.',wth:'160px'},
                      {prop:'serviceName',label:'Service Name',wth:'150px'},
                      {prop:'subServiceName',label:'Sub Service Name',wth:'200px'},
                      {prop:'status',label:'Status',fmt:status,wth:'150px'},
                      {prop:'vendor',label:'Vendor',wth:'150px'},
                      {prop:'employee',label:'Employee',wth:'150px'},
                      {prop:'userName',label:'Customer Name',wth:'150px'},
                      {prop:'phone',label:'Customer Phone',wth:'140px'},
                      {prop:'specificNote',label:'Service Description',wth:'160px'},
                      {prop:'bookingTime',label:'Appointment Date',fmt:selfTimeFormat,wth:'160px'},
                      {prop:'address',label:'Address',wth:'250px'},
                      {prop:'postalCode',label:'Postal Code',wth:'110px'},
                      {prop:'userNote',label:'Remark',wth:'250px'},
                      ]"
                    align="center"
                    :width="item.wth"
                    :formatter="item.fmt"
                    :prop="item.prop"
                    :label="item.label"
                    :key="item.label">
            </el-table-column>

            <el-table-column label="Action" fixed="right" width="130px">
                <template slot-scope="s">
                    <el-dropdown placement="bottom">
                        <el-button type="primary">
                            Actions<i class="el-icon-arrow-down el-icon--right"></i>
                        </el-button>

                        <el-dropdown-menu slot="dropdown">
                            <el-button v-if="s.row.status===2" size="mini" @click="openAssign(s.row)"
                                       icon="el-icon-user-solid"></el-button>

                            <el-button icon="el-icon-printer"
                                       size="mini"
                                       @click="rc(s.row.id)">RC
                            </el-button>

                            <el-button icon="el-icon-printer"
                                       size="mini"
                                       @click="iv(s.row.id)">IV
                            </el-button>

                            <el-button icon="el-icon-printer"
                                       size="mini"
                                       @click="rp(s.row.id)">RP
                            </el-button>

                            <el-button icon="el-icon-printer"
                                       size="mini"
                                       @click="qu(s.row.id)">QU
                            </el-button>

                            <el-button icon="el-icon-coin" v-if="isEazable"
                                       size="mini"
                                       @click="settle(s.row.id)">Settle
                            </el-button>
                        </el-dropdown-menu>
                    </el-dropdown>
                </template>
            </el-table-column>
        </el-table>

        <div class="page">
            <el-pagination v-if="page.total>1"
                           @current-change="loadData"
                           :page-size="page.size"
                           :current-page.sync="page.page"
                           :page-count="page.totalPage"
                           layout="prev, pager, next"
                           :total="data.total">
            </el-pagination>
        </div>
    </div>
</template>

<!--suppress JSUnusedGlobalSymbols -->
<script>
    import {
        homeServiceExport,
        homeServiceOrder,
        homeServiceOrderIv,
        homeServiceOrderRc,
        homeServiceOrderSettle,
        homeServiceQuote,
        homeServiceReport
    } from '@/api/HomeserviceApi'
    import {vendorList} from '@/api/VendorAPI'
    import {excelRequestRequest, pdfRequestRequest} from '@/utils/ApiUtils'
    import {mapGetters} from "vuex";

    export default {
        name: 'HkOrderList',
        data() {
            return {
                loading: false,
                data: [],
                page: {'page': 1, 'size': 10, 'totalPage': 1, 'total': 0},
                dialogVisible: false,
                employee: [],
                vendors: [],
                orderId: null,
                queryForm: {
                    startStatus: '3',
                    endStatus: '3'
                },
                orderStatus: {
                    2: 'New',
                    3: 'Matching',
                    4: 'Matched',
                    5: 'Vendor Accepted',
                    6: 'User Rescheduled',
                    7: 'Vendor Rescheduled',
                    8: 'Arrived',
                    9: 'Quoted',
                    10: 'Quoted and Rescheduled',
                    11: 'Quote Rejected',
                    12: 'Quote Accepted',
                    13: 'Servicing',
                    14: 'Service Completed',
                    15: 'Order Completed',
                    16: 'Matching Failed',
                    17: 'User Cancelled',
                    18: 'Vendor Cancelled',
                }
            }
        },
        methods: {
            iv(orderId) {
                pdfRequestRequest(orderId, homeServiceOrderIv)
            },
            rc(orderId) {
                pdfRequestRequest(orderId, homeServiceOrderRc)
            },
            qu(orderId) {
                pdfRequestRequest(orderId, homeServiceQuote)
            },
            rp(orderId) {
                pdfRequestRequest(orderId, homeServiceReport)
            },
            loadData() {
                this.$pageUtils(this, homeServiceOrder);
            },
            status(row, cell, val) {
                return this.orderStatus[val]
            },
            settle(orderId) {
                if (confirm('Mark this order to settled?')) {
                    homeServiceOrderSettle(orderId)
                        .then(() => {
                            this.loadData();
                        })
                }
            },
            exportData() {
                excelRequestRequest(this, homeServiceExport);
            }
        },
        computed: mapGetters({
            isEazable: 'isEazable'
        }),
        mounted() {
            this.queryForm = {
                startStatus: '3',
                endStatus: '3'
            }
            this.loadData()
            vendorList({company: true})
                .then(res => {
                    this.vendors = res.data.content
                })
            vendorList({company: false})
                .then(res => {
                    this.employee = res.data.content
                })
        }
    };
</script>

<style scoped>
    el-button + el-button {
        padding-left: unset;
    }

    .el-dropdown-menu{
        padding: 10px;
    }
</style>
